/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedTradePointsEarnedMessage_priceInfoDisplay = {
    readonly " $fragmentRefs": FragmentRefs<"PointsEarnedMessage_priceInfoDisplay">;
    readonly " $refType": "PdpSharedTradePointsEarnedMessage_priceInfoDisplay";
};
export type PdpSharedTradePointsEarnedMessage_priceInfoDisplay$data = PdpSharedTradePointsEarnedMessage_priceInfoDisplay;
export type PdpSharedTradePointsEarnedMessage_priceInfoDisplay$key = {
    readonly " $data"?: PdpSharedTradePointsEarnedMessage_priceInfoDisplay$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradePointsEarnedMessage_priceInfoDisplay">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedTradePointsEarnedMessage_priceInfoDisplay",
  "type": "PriceInfoDisplay",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PointsEarnedMessage_priceInfoDisplay",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'f7ded11a027a185f6a78b91852e8a177';
export default node;
